module.exports = __webpack_public_path__ + "img/戴璐强@2x.62694cca.png";